import { ReactNode } from "react";

export const disableable = function(
  node: ReactNode | false,
  defaultNode: ReactNode
) {
  return node !== false && (node || defaultNode);
};
